import {Button} from '@logistics-frontend/blocks/lpc/button'
import {useI18n} from '@logistics-frontend/core/i18n'
import {makeStyles} from '@material-ui/core/styles'
import {AsyncStatus, useTariffsState} from '@yandex-taxi/react-integration-api'
import React, {useCallback} from 'react'

import {useMaxRoutePoints} from 'src/components/hooks'
import {useMapRoute as useRoute} from 'src/components/map-bounds'
import {canAddAddress} from 'src/components/utils'

import {useAddPointsGoalCallback} from '../../../shared/metrika'

const useButtonClasses = makeStyles(theme => ({
  root: {
    justifyContent: 'space-between',
    borderColor: 'transparent',
    padding: 0,
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
    },
  },
  endIcon: {
    fontSize: 24,
  },
}))

export const AddAddressButton: React.FC = () => {
  const t = useI18n()
  const [{value: route = []}, {push}] = useRoute()
  const buttonClasses = useButtonClasses()
  const goalCallback = useAddPointsGoalCallback()
  const {status} = useTariffsState()
  const maxRoutePoints = useMaxRoutePoints()
  const disableButton = !canAddAddress(maxRoutePoints, route) || status === AsyncStatus.PENDING
  const clickHandler = useCallback(() => {
    push()
    goalCallback()
  }, [goalCallback, push])

  return (
    <Button classes={buttonClasses} disabled={disableButton} onClick={clickHandler} startIcon="＋">
      {t('order.form.address.add_address', 'Добавить адрес доставки')}
    </Button>
  )
}
